import { render } from "./Classified.vue?vue&type=template&id=1a6749f8&scoped=true"
import script from "./Classified.vue?vue&type=script&lang=js"
export * from "./Classified.vue?vue&type=script&lang=js"

import "./Classified.vue?vue&type=style&index=0&id=1a6749f8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6749f8"]])

export default __exports__